define([
    'edge/platform/atomic_design/molecules/module'
], ()=> {
    return angular.module('edge.platform.atomic_design', [
        'edge.platform.atomic_design.molecules'
    ]);
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/atomic_design/module.js
 **/